module.exports = __webpack_public_path__ + "media/72.89246b53.mp3";